import { render, staticRenderFns } from "./TeamSurveyQuestionList.vue?vue&type=template&id=20952a62&"
import script from "./TeamSurveyQuestionList.vue?vue&type=script&lang=js&"
export * from "./TeamSurveyQuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports